module.exports = __webpack_public_path__ + "media/images/icons/phone--orange-f7d20449f8369b2eb963e6d883a54711.png";